const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^192\.168\./) ||
    window.location.hostname.match(/^10\./) ||
    window.location.hostname.match(/^172\.(1[6-9]|2[0-9]|3[0-1])\./)
);

const API_BASE_URL = isLocalhost
    ? `http://${window.location.hostname}:9090/api`
    : 'https://shreesamrudh.com/api';

export default API_BASE_URL;
